/*
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2023-03-23 11:41:25
 * @Description: 路由
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//以下代码解决路由地址重复的报错问题
// const originalPush = VueRouter.prototype.push
//    VueRouter.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

const routes = [
  //首页
  {
    path: '/',
    redirect: {
      name: 'Home',
    }
  },
  {
    path: '/home',
    name: 'Home',
    meta: { pathSet: "/home" },
    component: () => import("@/views/home/Home.vue")
  },
  //注册
  {
    path: '/register',
    name: 'Register',
    component: () => import("@/views/login/Register.vue")
  },
  //登录
  {
    path: '/login',
    name: 'Login',
    component: () => import("@/views/login/Login.vue")
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: () => import("@/views/login/ForgetPassword.vue")
  },
  //api文档
  {
    path: '/apiDoc',
    name: 'ApiDoc',
    redirect: { name: 'apiDocIndex' },
    component: () => import("@/views/apiDoc/Index.vue"),
    children: [{
      path: "/apiDoc/index",
      name: "apiDocIndex",
      meta: { pathSet: "/apiDoc", title: "极兔API简介" },
      component: () => import("@/views/apiDoc/apiDocIndex.vue"),
    }, {
      path: "/apiDoc/item/create",
      name: "createItem",
      meta: { pathSet: "/apiDoc", title: "创建货品", apiKey: 'createItemApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    }, {
      path: "/apiDoc/item/query",
      name: "queryItem",
      meta: { pathSet: "/apiDoc", title: "查询货品", apiKey: 'queryItemApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    }, {
      path: "/apiDoc/order/inbound/create",
      name: "createInbound",
      meta: { pathSet: "/apiDoc", title: "创建入库单", apiKey: 'createInboundApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    }, {
      path: "/apiDoc/order/inbound/query",
      name: "queryInbound",
      meta: { pathSet: "/apiDoc", title: "查询入库单", apiKey: 'queryInboundApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    }, {
      path: "/apiDoc/order/inbound/return",
      name: "returnInbound",
      meta: { pathSet: "/apiDoc", title: "入库单回传", apiKey: 'returnInboundApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    }, {
      path: "/apiDoc/order/outbound/create",
      name: "createOutbound",
      meta: { pathSet: "/apiDoc", title: "出库单创建", apiKey: 'createOutboundApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    }, {
      path: "/apiDoc/order/outbound/query",
      name: "queryOutbound",
      meta: { pathSet: "/apiDoc", title: "查询出库单", apiKey: 'queryOutboundApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    }, {
      path: "/apiDoc/order/outbound/return",
      name: "returnOutbound",
      meta: { pathSet: "/apiDoc", title: "出库单回传", apiKey: 'returnOutboundApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    {
      path: "/apiDoc/order/cancel",
      name: "cancelOrder",
      meta: { pathSet: "/apiDoc", title: "单据取消", apiKey: 'cancelOrderApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    // 库存
    {
      path: "/apiDoc/inventory/query",
      name: "queryInventory",
      meta: { pathSet: "/apiDoc", title: "库存查询", apiKey: 'queryInventoryApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    {
      path: "/apiDoc/inventory/snapshotQuery",
      name: "queryInventorySnapshot",
      meta: { pathSet: "/apiDoc", title: "库存快照查询", apiKey: 'queryInventorySnapshotApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    {
      path: "/apiDoc/inventory/return",
      name: "returnInventory",
      meta: { pathSet: "/apiDoc", title: "库存异动回传", apiKey: 'returnInventoryApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    {
      path: "/apiDoc/other/queryInventoryWarehouse",
      name: "queryInventoryWarehouse",
      meta: { pathSet: "/apiDoc", title: "查询备货仓库", apiKey: 'queryInventoryWarehouseApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    // 其他
    {
      path: "/apiDoc/other/queryTrajectory",
      name: "queryTrajectory",
      meta: { pathSet: "/apiDoc", title: "查询出库单轨迹", apiKey: 'queryTrajectoryApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    {
      path: "/apiDoc/other/combinedOrderForecast",
      name: "combinedOrderForecast",
      meta: { pathSet: "/apiDoc", title: "合单预报", apiKey: 'combinedOrderForecastApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    {
      path: "/apiDoc/other/login",
      name: "deviceLogin",
      meta: { pathSet: "/apiDoc", title: "设备登录", apiKey: 'deviceLoginApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    {
      path: "/apiDoc/other/uploadWeight",
      name: "uploadWeight",
      meta: { pathSet: "/apiDoc", title: "称重设备上传重量", apiKey: 'uploadWeightApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    },
    {
      path: "/apiDoc/other/containerBind",
      name: "containerBind",
      meta: { pathSet: "/apiDoc", title: "容器绑定", apiKey: 'containerBindApi' },
      component: () => import("@/views/apiDoc/children/index.vue"),
    }
  ]
  },
  //个人中心
  {
    path: "/personalCenter",
    name: "PersonalCenter",
    component: () => import("@/views/personalCenter/Index.vue")
  },
  //控制台
  {
    path: "/control",
    name: "Control",
    meta: { pathSet: "/control" },
    component: () => import("@/views/control/Index.vue")
  },
  {
    path: "/helpCenter",
    name: "HelpCenter",
    meta: { pathSet: "/helpCenter" },
    component: () => import("@/views/helpCenter/Index.vue")
  },
  // 管我们
  {
    path: "/aboutUs",
    name: "AboutUs",
    meta: { pathSet: "/aboutUs" },
    component: () => import("@/views/aboutUs/Index.vue")
  }
]

const router = new VueRouter({
  //   mode: 'history',
  routes
})
router.afterEach(() => {
  const box = document.querySelector('.main-r-bottom')
  if (box) box.scrollTop = 0
})
export default router
